<template>
  <v-layout>
    <v-avatar class="shrink ma-1" size="16">
      <img v-if="iconExists" :src="webpage.icon" alt="site logo" @error="iconExists = false" />
    </v-avatar>

    <v-col class="pa-0 grow truncate">
      <a
        class="caption shrink font-weight-bold pr-2 py-0"
        @click.stop
        :href="webpage.url"
        target="_blank"
        >{{ webpage.provider }}</a
      >
      <span class="caption px-0 py-0 truncate">{{ webpage.title }}</span>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    webpage: { default: () => ({}) }
  },
  data() {
    return {
      iconExists: true
    };
  },
  computed: {},
  methods: {}
};
</script>

<style>
.site-info div {
  line-height: 1.3 !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
